module.exports = "/_next/static/images/green-sticker_ru-875f76bddc16eb274e856e3cd5540952.png";